// pages/CareGuide.jsx
import React from "react";
import Navigation from "../components/Common/header/Navigation";
import Footer from "../components/Common/footer/Footer";
import "../styles/Pages.css";

const CareGuide = () => {
    return (
        <div className="page-shell">
            <Navigation />

            {/* ── Hero ── */}
            <section className="page-hero">
                <div className="page-hero-border" />
                <div className="container" style={{ position: "relative", zIndex: 1 }}>
                    <span className="page-hero-eyebrow">Hair Care</span>
                    <h1 className="page-hero-title">The Care Code</h1>
                    <p className="page-hero-subtitle">
                        Keep your bundles looking flawless with our expert care guide
                    </p>
                    <div className="page-hero-rule" />
                </div>
            </section>

            {/* ── Bundle Care ── */}
            <section className="page-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="page-card">
                                <h2 className="page-card-title">
                                    <i className="fas fa-shield-alt" /> Bundle Care
                                </h2>
                                <p style={{ fontFamily: "var(--font-display)", fontSize: "1.05rem", lineHeight: 2, color: "var(--text-secondary)", margin: "0 0 20px" }}>
                                    Keep your bundles soft and shiny by using a light, sulphate-free leave-in conditioner. Always detangle gently
                                    from the ends up, and wrap your hair at night with a silk or satin scarf to prevent frizz. Wash with lukewarm
                                    water and minimal shampoo, and limit heat styling to protect natural shine and longevity.
                                </p>
                                <div className="page-note page-note--warning">
                                    <strong>Important Note:</strong> Bundle Madness cannot accept liability for damage, discolouration, shedding, or tangling caused by colouring, misuse, or improper care. While our extensions are designed to deliver excellent results, outcomes from dyeing, bleaching, or chemical treatments are beyond our control.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Lace Care ── */}
            <section className="page-section page-section--raised">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="page-card">
                                <h2 className="page-card-title">
                                    <i className="fas fa-heart" /> Lace Care
                                </h2>
                                <p style={{ fontFamily: "var(--font-display)", fontSize: "1.05rem", lineHeight: 2, color: "var(--text-secondary)", margin: "0 0 20px" }}>
                                    Treat your lace with love — pat it gently when washing and avoid heavy oils or gels
                                    that can weaken knots. Be mindful around the hairline when applying or removing glue,
                                    and store your lace flat or on a wig stand to maintain its shape.
                                </p>
                                <div className="page-note page-note--tip">
                                    <strong>Pro Tip:</strong> Always test new dyes or adhesives on a small section first.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Colouring ── */}
            <section className="page-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="page-card">
                                <h2 className="page-card-title">
                                    <i className="fas fa-palette" /> Colouring Tips
                                </h2>
                                <p style={{ fontFamily: "var(--font-display)", fontSize: "1.05rem", lineHeight: 2, color: "var(--text-secondary)", margin: "0 0 20px" }}>
                                    Keep your bundles healthy and vibrant by pre-conditioning before colouring.
                                    Test a small section first, rinse with cool water to lock in colour, and avoid
                                    over-processing. Weekly deep conditioning keeps your coloured hair silky, soft,
                                    and stunning.
                                </p>
                                <div className="page-note page-note--danger">
                                    <strong>Professional Advice:</strong> Customers are advised to consult a professional
                                    stylist experienced with extensions for any colouring services.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Quick Checklist ── */}
            <section className="page-section page-section--raised">
                <div className="container">
                    <h2 className="page-section-title">Quick Care Checklist</h2>
                    <p className="page-section-subtitle">Your daily routine for lasting beauty</p>

                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="row">
                                <div className="col-md-6">
                                    <ul className="care-checklist">
                                        <li><i className="fas fa-check" />Use sulphate-free products</li>
                                        <li><i className="fas fa-check" />Detangle from ends to roots</li>
                                        <li><i className="fas fa-check" />Sleep with silk / satin protection</li>
                                        <li><i className="fas fa-check" />Wash with lukewarm water</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <ul className="care-checklist">
                                        <li><i className="fas fa-check" />Limit heat styling</li>
                                        <li><i className="fas fa-check" />Test dyes on small sections first</li>
                                        <li><i className="fas fa-check" />Store properly when not in use</li>
                                        <li><i className="fas fa-check" />Consult professionals for colouring</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default CareGuide;